@if ((regulation$ | async); as regulation) {
  <div class="accordeon-tab">
    <input type="checkbox" id="chck2" class="acordeon">
    <label class="accordeon-tab-label" for="chck2">
      <h2>{{regulation.data.attributes.titel | uppercase}}</h2>
    </label>
    <div class="accordeon-tab-content">
      <span [innerHtml]="regulation.data.attributes.text"></span><br>
    </div>
  </div>
}